import { literal, string, struct } from 'io-ts/lib/Decoder';

/**
 * Sent when an opening is removed from a frame.
 * Server will recompute the frame geometry after removal.
 */
export const OpeningDeleted = struct({
	type: literal('opening-deleted'),
	frameId: string,
	openingId: string,
});
